import {createAction} from "redux-actions";
import {SET_ADMINISTRATORS} from "./administrators_table_type";

export const setAdministrators = createAction(SET_ADMINISTRATORS);
